/**
 * Global Constants
 * 
 * Centralized configuration for global constants across the application.
 * Update these values to change application-wide settings.
 */

// ============================================
// Debug and Security Configuration
// ============================================

const IS_DEBUG = process.env.REACT_APP_DEBUG_MODE === 'true';

const IS_LOCALHOST = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/**
 * Enable/disable debug mode
 * If true, shows a token input in the header for manual token entry
 * @type {boolean}
 */
export const DEBUG_MODE_ENABLED = IS_DEBUG && IS_LOCALHOST;

/**
 * Enable/disable encryption for API requests
 * @type {boolean}
 */
export const ENCRYPTION = IS_DEBUG ? false : true;

/**
 * Enable/disable authentication requirement
 * If true, works with standard authentication (Snow)
 * If false, bypasses sign-in and goes directly to /chat
 * @type {boolean}
 */
export const REQUIRE_AUTH = IS_DEBUG ? false : true;

/**
 * Enable/disable RBAC (Role-Based Access Control)
 * @type {boolean}
 */
export const RBAC_ENABLED = IS_DEBUG ? false : true;

// ============================================
// File Upload Configuration
// ============================================

/**
 * Maximum number of files allowed per upload
 * @type {number}
 */
export const UPL_GENIE_DOCUMENT_FILE_COUNT_LIMIT = 5;

/**
 * Maximum file size for document uploads (50MB in bytes)
 * @type {number}
 */
export const UPL_GENIE_DOCUMENT_FILE_SIZE_LIMIT = 50 * 1024 * 1024;

/**
 * Maximum file size for translation document uploads (20MB in bytes)
 * @type {number}
 */
export const TRANSLATE_AI_FILE_SIZE_LIMIT = 20 * 1024 * 1024;


export const UPL_GENIE_PROMPT_CHAR_LIMIT = 150000;
